
































































import Vue from "vue";
import { extend, ValidationProvider } from "vee-validate";
// components
import PeriodSpecification from "@/commons/components/PeriodSpecification.vue";
// Enum
import { Enum } from "@/commons/enums/Type";
import { PeriodEnum } from "@/commons/enums/Period";
import { ReportTypeEnum } from "@/features/analytics/enums/ReportType";

extend("nameSyntax", {
  validate(value) {
    const nameRegex = new RegExp(
      /[^a-zA-Z0-9ａ-ｚＡ-Ｚ０-９\u3041-\u3096\u30A1-\u30FA\u4E00-\u9FFF（）〔〕［］｛｝〈〉《》「」『』【】＿ー―‐：\-_()\s]/
    );
    return !nameRegex.test(value);
  },
});

export default Vue.extend({
  components: {
    "validation-provider": ValidationProvider,
    "period-specification": PeriodSpecification,
  },
  props: {
    reportTypeInput: { type: Number, required: true },
    reportNameInput: { type: String, required: true },
    periodInput: { type: Number, required: true },
    startDateInput: { type: String, required: true },
    endDateInput: { type: String, required: true },
    isAdhoc: { type: Boolean, required: true },
  },
  computed: {
    period(): Enum[] {
      if (this.reportTypeInput === ReportTypeEnum.PREBID_ANALYTICS.value) {
        return [
          {
            value: PeriodEnum.LAST_SEVEN_DAYS.value,
            text: PeriodEnum.LAST_SEVEN_DAYS.jaText,
          },
          {
            value: PeriodEnum.PERIOD_SPECIFICATION.value,
            text: PeriodEnum.PERIOD_SPECIFICATION.jaText,
          },
        ];
      } else if (
        this.reportTypeInput === ReportTypeEnum.BI_REPORT.value ||
        this.reportTypeInput === ReportTypeEnum.GOOGLE_AD_MANAGER.value
      ) {
        return PeriodEnum.getListByLanguage();
      }

      return [];
    },
    localReportNameInput: {
      // NOTE: computed で getter, setter を使用すると this の型推論ができなくなるケースあり
      get(this: any) {
        return this.reportNameInput;
      },
      set(val) {
        return this.$emit("update:reportNameInput", val);
      },
    },
    localPeriodInput: {
      get() {
        return this.periodInput;
      },
      set(val) {
        return this.$emit("update:periodInput", val);
      },
    },
    localStartDateInput: {
      get() {
        return this.startDateInput;
      },
      set(val) {
        return this.$emit("update:startDateInput", val);
      },
    },
    localEndDateInput: {
      get() {
        return this.endDateInput;
      },
      set(val) {
        return this.$emit("update:endDateInput", val);
      },
    },
  },
});
